// extracted by mini-css-extract-plugin
module.exports = {"progress-block":"progress-block___3uWco","completed":"completed___11Dq0","progress-bar":"progress-bar___145S9","item":"item___1a7Nx","remove-icon":"remove-icon___2y8U4"};